import * as R from "ramda";
import {
  KpiData,
  KpiInfo,
  Metric,
  MetricTotalsByDate,
} from "@blisspointmedia/bpm-types/dist/CrossChannel";
import React, { useMemo } from "react";
import FunnelDynamics from "../Components/FunnelDynamics";
import KpiVolume from "../Components/KpiVolume";
import MarketingInputs from "../Components/MarketingInputs";
import { FullPageSpinner } from "../../Components";

interface TotalBusinessProps {
  kpiInfo: KpiInfo;
  deliveryData: MetricTotalsByDate[];
  marketingInputs: any[] | undefined;
  channelClassification: Record<string, string> | undefined;
  defaultFunnelDynamicsPreset: string | undefined;
}

const TotalBusiness: React.FC<TotalBusinessProps> = ({
  kpiInfo,
  deliveryData,
  marketingInputs,
  channelClassification,
  defaultFunnelDynamicsPreset,
}) => {
  const { kpiData, funnelPresets } = kpiInfo || { kpiData: [], funnelPresets: [], sources: [] };

  const funnelData = useMemo(() => addDeliveryMetricsToKpiData(deliveryData, kpiData), [
    deliveryData,
    kpiData,
  ]);

  return (
    <div className="ccTotalBusiness">
      {kpiInfo && marketingInputs && channelClassification ? (
        <div className="ccTopSection">
          <div className="ccTopSectionLeftSide">
            <div className="ccDailyKpiVolume">
              <KpiVolume data={kpiData} />
            </div>

            <div className="ccMarketingInputs">
              <MarketingInputs
                data={marketingInputs}
                channelClassification={channelClassification}
              />
            </div>
          </div>
          <div className="ccTopSectionRightSide">
            <div className="ccKpiFunnel">
              <FunnelDynamics
                data={funnelData}
                funnelPresets={funnelPresets}
                defaultPreset={defaultFunnelDynamicsPreset}
              />
            </div>
          </div>
        </div>
      ) : (
        <FullPageSpinner />
      )}
    </div>
  );
};

/**
 * Adds Clicks and Impressions to KPI data because they are allowed as Funnel options
 * @param {metricsData[]} metricsData
 * @param {kpiData[]} kpiData
 * @returns {kpiData[]} kpiData with Clicks and Impressions
 */
const addDeliveryMetricsToKpiData = (metricsData: MetricTotalsByDate[], kpiData: KpiData[]) => {
  let clicks: KpiData[] = [];
  let impressions: KpiData[] = [];

  metricsData.forEach(row => {
    clicks.push({
      date: row.date,
      kpi: "Clicks",
      count: R.pathOr(0, ["metrics", Metric.CLICKS], row),
      revenue: 0,
      isOrganic: false,
    });

    impressions.push({
      date: row.date,
      kpi: "Impressions",
      count: R.pathOr(0, ["metrics", Metric.IMPRESSIONS], row),
      revenue: 0,
      isOrganic: false,
    });
  });

  return [...kpiData, ...clicks, ...impressions];
};

export default TotalBusiness;
